import uniqBy from 'lodash/uniqBy';
import { matchTypes } from '../components/types/criteria';

export const getProjectAudienceVariables = ({ audience = {}, criteria = {} }) => {
  const { columns = [] } = audience;
  const audienceVariables = [];

  Object.values(criteria).forEach((criteriaItem) => {
    audienceVariables.push(...getAudienceVariables(criteriaItem, columns));
  });

  return uniqBy(
    audienceVariables.map((variable) => {
      const { options } = variable;
      variable.options = options.map((option) => {
        const { label, ...rest } = option;
        return { ...rest, text: label };
      });
      return variable;
    }),
    'id'
  );
};

const emptyOption = {
  key: -1,
  label: '-- Nothing selected --',
  value: null,
};

const getAudienceVariables = (criteriaItem = {}, columns = []) => {
  const { items = [] } = criteriaItem;
  const audienceVariables = [];

  items.forEach((item) => {
    const { matches = {} } = item || {};

    Object.values(matches).forEach((match) => {
      const variablesColNumbers = audienceVariables.map((variable) => variable.id);
      if (
        match.type === matchTypes.AUDIENCE_VARIABLE &&
        columns[match.value] &&
        !variablesColNumbers.includes(+match.value)
      ) {
        const { colNumber, name, values = [] } = columns[match.value] || {};
        const options = values.map((value) => ({
          key: value,
          label: value,
          value: value,
        }));

        audienceVariables.push({
          id: colNumber,
          name,
          options: [emptyOption, ...options],
        });
      }
    });
  });

  return audienceVariables;
};

// TODO: Check for removal
//
// const getQuestionVariables = (criteriaItem = {}, questions = {}, allOptions = {}) => {
//   const { items = [] } = criteriaItem;
//   const questionVariables = [];
//
//   items.forEach(item => {
//     const { matches = {} } = item || {};
//
//     Object.values(matches).forEach(match => {
//       const variablesFrontendIds = questionVariables.map(variable => variable.id);
//       if (
//         match.type === matchTypes.QUESTION &&
//         !variablesFrontendIds.includes(+match.value)
//       ) {
//         const { frontendId, title: name, options: questionOptions = [], config = {} } = questions[match.value] || {};
//         const options = questionOptions.map(frontendId => {
//           const { label, position } = allOptions[frontendId] || {};
//
//           return ({
//             key: frontendId,
//             label: striptagsAndUnescapeText(label),
//             value: position,
//           });
//         });
//
//         questionVariables.push({
//           id: frontendId,
//           name: striptagsAndUnescapeText(name),
//           options: [emptyOption, ...options],
//           maxResponses: config.maxResponses,
//         });
//       }
//     });
//   });
//
//   return questionVariables;
// };
//
// const getConstantValues = (criteriaItem = {}) => {
//   const { items = [], variables = [] } = criteriaItem;
//   const constantValues = [];
//
//   items.forEach(item => {
//     const { matches = {} } = item || {};
//
//     Object.keys(matches).forEach(colNumber => {
//       const match = matches[colNumber] || {};
//       if (
//         match.value !== undefined &&
//         match.type === matchTypes.CONSTANT &&
//         !constantValues.map(constant => constant.value).includes(match.value)
//       ) {
//         const { name: label = '' } = variables.find(variableItem => (
//           variableItem.colNumber === +colNumber
//         )) || {};
//         constantValues.push({
//           label,
//           value: match.value,
//         });
//       }
//     });
//   });
//
//   return constantValues;
// };
//
// export const getVariables = ({ type, frontendId, state = {} }) => {
//   const {
//     activeProject: {
//       present: {
//         audience = {},
//         criteria = {},
//         items = {},
//         options = {},
//       } = {},
//     } = {},
//   } = state;
//   const questionCriteria = criteria[frontendId] || {};
//   const { columns = [] } = audience;
//
//   switch (type) {
//     case viewerTypes.CONJOINT_CARDS:
//       return {
//         audience: getAudienceVariables(questionCriteria, columns),
//         questions: getQuestionVariables(questionCriteria, items, options),
//         constants: getConstantValues(questionCriteria),
//       };
//     default:
//       return {};
//   }
// };
//
//
// export const getCriteriaFilterData = ({ variables, items, criteria }) => {
//   const params = {};
//   variables.questions.forEach(question => {
//     const filter = [];
//     const itemCriteria = criteria[question.id];
//     const questionObject = items[question.id] || {};
//     const questionConfig = questionObject.config || {};
//     const shouldSkip = !itemCriteria || !questionConfig.columnsToFetch || questionObject.type === ITEM_TYPES.conjoint;
//     if (shouldSkip) {
//       return;
//     }
//     for (const criteria of itemCriteria.items) {
//       const matches = criteria.matches || {};
//       const constantFilters = Object.keys(matches).filter(column => matches[column].type === matchTypes.CONSTANT);
//       const criteriaFilters = constantFilters.map(column => ({
//         column,
//         value: matches[column].value
//       }));
//       filter.push(criteriaFilters);
//     }
//     params[question.id] = {
//       filter,
//       datasheetId: questionConfig.datasheetId,
//       columnsToFetch: questionConfig.columnsToFetch
//     };
//   });
//   return params;
// };
//
// export const addDatasheetIdsToRows = ({ rows = [], optionsWithIds = [], idRowFrontendId, datasheetForItem }) => {
//   if (!datasheetForItem) {
//     return rows;
//   }
//   const lastPosition = rows.reduce((acc, curr) => curr.position > acc ? curr.position : acc, 1);
//   const idRow = {
//     isIdRow: true,
//     frontendId: idRowFrontendId,
//     position: lastPosition + 1,
//     label: 'ID',
//     levels: optionsWithIds.filter(option => option.attributeId === idRowFrontendId).map(option => option.frontendId)
//   };
//   return [...rows, idRow];
// };
//
// export const addDatasheetIdsToOptions = ({ options = [], idRowFrontendId, datasheetForItem }) => {
//   if (!datasheetForItem) {
//     return options;
//   }
//   const idColumn = +datasheetForItem.columnId;
//   const values = datasheetForItem.columns[idColumn].values || [];
//   let lastPosition = options.reduce((acc, curr) => curr.position > acc ? curr.position : acc, 1);
//   const importedOptionParentId = [uuid()];
//   const idOptions = values.map(value => ({
//     isIdOption: true,
//     frontendId: uuid(),
//     attributeId: idRowFrontendId,
//     position: ++lastPosition,
//     datasheetColumnNumber: [+idColumn],
//     importedOptionParentId,
//     label: `${value}`
//   }));
//   return [...options, ...idOptions];
// };
//
// export const addDatasheetIdsToOptionGroupingRules = ({ config, idRowFrontendId, datasheetForItem, optionsWithIds }) => {
//   if (!config.optionGroupingRules || !datasheetForItem) {
//     return config.optionGroupingRules;
//   }
//   const idOptions = optionsWithIds.filter(level => level.attributeId === idRowFrontendId);
//   return config.optionGroupingRules.map(group => ({
//     ...group,
//     levels: {
//       ...group.levels,
//       [idRowFrontendId]: idOptions.map(level => getLevelStringForGroup(level, level.frontendId))
//     }
//   }));
// };
